// frontend/src/stores/dashboard-settings.store.ts
import { Store, useStore } from '@tanstack/react-store'

const LOCAL_STORAGE_KEY = 'cortado_dashboard_settings'

type DaysAheadOption = 7 | 14 | 30
type RecencyDaysOption = 7 | 30 | 90

interface DashboardSettingsState {
  pendingTasksDaysAhead: DaysAheadOption
  upcomingPaymentsDaysAhead: DaysAheadOption
  leadsRecencyDays: RecencyDaysOption
}

const defaultState: DashboardSettingsState = {
  pendingTasksDaysAhead: 7,
  upcomingPaymentsDaysAhead: 7,
  leadsRecencyDays: 7,
}

function loadFromStorage(): DashboardSettingsState {
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY)
    if (stored) {
      return { ...defaultState, ...JSON.parse(stored) }
    }
  } catch (e) {
    console.warn('Failed to load dashboard settings:', e)
  }
  return defaultState
}

function saveToStorage(state: DashboardSettingsState) {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state))
  } catch (e) {
    console.warn('Failed to save dashboard settings:', e)
  }
}

export const dashboardSettingsStore = new Store<DashboardSettingsState>(loadFromStorage())

export const dashboardSettingsActions = {
  setPendingTasksDaysAhead: (days: DaysAheadOption) => {
    dashboardSettingsStore.setState((state) => {
      const newState = { ...state, pendingTasksDaysAhead: days }
      saveToStorage(newState)
      return newState
    })
  },
  setUpcomingPaymentsDaysAhead: (days: DaysAheadOption) => {
    dashboardSettingsStore.setState((state) => {
      const newState = { ...state, upcomingPaymentsDaysAhead: days }
      saveToStorage(newState)
      return newState
    })
  },
  setLeadsRecencyDays: (days: RecencyDaysOption) => {
    dashboardSettingsStore.setState((state) => {
      const newState = { ...state, leadsRecencyDays: days }
      saveToStorage(newState)
      return newState
    })
  },
}

export function usePendingTasksDaysAhead() {
  return useStore(dashboardSettingsStore, (s) => s.pendingTasksDaysAhead)
}

export function useUpcomingPaymentsDaysAhead() {
  return useStore(dashboardSettingsStore, (s) => s.upcomingPaymentsDaysAhead)
}

export function useLeadsRecencyDays() {
  return useStore(dashboardSettingsStore, (s) => s.leadsRecencyDays)
}
